<div class="tw-min-h-screen tw-bg-gradient-to-br tw-from-slate-900 tw-via-blue-950 tw-to-indigo-950
            tw-flex tw-items-center tw-justify-center tw-px-4 tw-py-16">
  <div class="tw-w-full tw-max-w-md">

    <!-- Logo -->
    <div class="tw-text-center tw-mb-8">
      <a routerLink="/">
        <img src="assets/img/logo.png" alt="TecGurus Empleos" class="tw-h-14 tw-mx-auto">
      </a>
    </div>

    <!-- Card -->
    <div class="tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-p-8">

      <!-- Header -->
      <div class="tw-text-center tw-mb-6">
        <div class="tw-w-14 tw-h-14 tw-mx-auto tw-mb-4 tw-rounded-xl tw-bg-brand-500/10 tw-flex tw-items-center tw-justify-center">
          <svg class="tw-w-7 tw-h-7 tw-text-brand-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"/>
          </svg>
        </div>
        <h1 class="tw-text-2xl tw-font-bold tw-text-slate-900">Recupera tu Contraseña</h1>
        <p class="tw-mt-1.5 tw-text-sm tw-text-slate-500">
          Ingresa tu correo y te enviaremos un enlace para restablecerla.
        </p>
      </div>

      <form [formGroup]="formRes" (ngSubmit)="enviarCorreo()" novalidate class="tw-space-y-4">

        <!-- Email -->
        <div>
          <label class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">
            Correo electrónico
          </label>
          <input type="email" formControlName="email" autocomplete="email"
                 placeholder="tu@correo.com"
                 class="tw-w-full tw-px-4 tw-py-2.5 tw-rounded-xl tw-border tw-border-slate-200 tw-text-sm tw-outline-none
                        focus:tw-ring-2 focus:tw-ring-brand-500/30 focus:tw-border-brand-500 tw-transition">
          <div *ngIf="formRes.controls.email.errors && envioCorreo" class="tw-mt-1 tw-text-xs tw-text-red-500">
            <span *ngIf="formRes.controls.email.errors.required">El correo es requerido.</span>
            <span *ngIf="formRes.controls.email.errors.pattern">Formato de correo inválido.</span>
          </div>
        </div>

        <!-- reCAPTCHA -->
        <div class="tw-flex tw-justify-center">
          <ngx-recaptcha2 formControlName="recaptcha"
              (success)="handleSuccess($event)"
              (reset)="handleReset()"
              (expire)="handleExpire()"
              (load)="handleLoad()"
              [siteKey]="calveSitio"
              [size]="'normal'"
              [hl]="lang">
          </ngx-recaptcha2>
        </div>

        <!-- Alerts -->
        <div *ngIf="envioCorreo && mensajeExito"
             class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-emerald-50 tw-border tw-border-emerald-200 tw-text-sm tw-text-emerald-700">
          {{ mensajeExito }}
        </div>
        <div *ngIf="envioCorreo && mensajeError"
             class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600">
          {{ mensajeError }}
        </div>
        <div *ngIf="mensajeUsuarioNull"
             class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600">
          {{ mensajeUsuarioNull }}
        </div>

        <!-- Submit -->
        <button type="submit" [disabled]="submitEnvioContacto"
                class="tw-w-full tw-py-2.5 tw-rounded-xl tw-bg-brand-600 hover:tw-bg-brand-700 tw-text-white
                       tw-font-semibold tw-text-sm tw-transition tw-duration-150 tw-border-0
                       disabled:tw-opacity-60 disabled:tw-cursor-not-allowed">
          Enviar correo de recuperación
        </button>

        <p class="tw-text-center tw-text-sm tw-text-slate-500">
          ¿Recordaste tu contraseña?
          <a routerLink="/acceder" class="tw-font-semibold tw-text-brand-600 hover:tw-underline">
            Iniciar sesión
          </a>
        </p>
      </form>
    </div>

  </div>
</div>
